import { useMemo } from 'react'

import { App } from '@/apps'
import { Metric } from '@/components/chart'
import useObject from '@/hooks/useObject'
import objectKeys from '@/util/object-keys'
import { accountSummary } from '@/watch-tower/thunks/statistics/account'
import colors from 'tailwindcss/colors'

export default function useMetrics(accountId: string) {
  const [summary] = useObject(accountSummary, { accountId })

  const global = useMemo((): Metric | undefined => {
    if (!summary) return

    return {
      id: 'count',
      name: 'Total',
      color: colors.blue[600],
      data: summary.global.map(data => ({
        id: data.date,
        date: data.date,
        count: data.count,
      })),
    }
  }, [summary])

  const apps = useMemo((): Record<App, Metric> | undefined => {
    if (!summary) return

    return objectKeys(summary.apps).reduce(
      (memo, app) => {
        memo[app] = {
          id: 'count',
          name: 'Total',
          color: colors.gray[300],
          data: summary.apps[app].map(data => ({
            id: data.date,
            date: data.date,
            count: data.count,
          })),
        }

        return memo
      },
      {} as Record<App, Metric>
    )
  }, [summary])

  return { global, apps }
}
